import { useMemo } from "react";
import { message } from "antd";
import { getHost } from "./getHost";

export interface HostToast {
  success: (text: string) => void;
  error: (text: string) => void;
  info: (text: string) => void;
}

export function useHostToast(): HostToast {
  return useMemo<HostToast>(
    () => ({
      success: (text) => {
        const host = getHost();
        if (host?.showToastSuccess) host.showToastSuccess(text);
        else void message.success(text);
      },
      error: (text) => {
        const host = getHost();
        if (host?.showToastError) host.showToastError(text);
        else void message.error(text);
      },
      info: (text) => {
        const host = getHost();
        if (host?.showToastInfo) host.showToastInfo(text);
        else void message.info(text);
      },
    }),
    [],
  );
}
